import { render } from "./SigninView.vue?vue&type=template&id=a60b5676"
import script from "./SigninView.vue?vue&type=script&lang=js"
export * from "./SigninView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nika/Sites/tanastsoroba-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__